export enum Format {
  Minute = 'mm',
  Hour = 'HH',
  Day = 'dd',
  Month = 'MM',
  Year = 'yyyy',
}
